import { PropType, defineComponent, ref } from 'vue'

import { CsCopyTextLink, CsModal, CsSecondaryButton, CsTooltip, CsTooltipModal, MsHeadline } from '@sunrise/components'
import { MsInformationCircle, MsLocator } from '@sunrise/icons'
import { screenSizeDetection, useGlobalStore } from '@sunrise/shared'
import { MLM, TrackingParameter, track } from '@sunrise/tracking'

import { LocationCoordinates } from '../../ts/mapper/decoratedEstateDetailMapper.interface'
import { PartnerLink } from '../../ts/mapper/partnerLinksMapper.interface'
import { useDetailStore } from '../../ts/store/detailStoreModule/detailStoreModule'

import MsGoogleMaps from '../MsGoogleMaps/MsGoogleMaps.vue'
import { buildMlmTrackingData, buildTealiumTrackingOpenMap, buildTealiumTrackingRelocationClick } from './MsMapTracking'
import MsPlaceholderMap from './placeholderMap.svg?component'

export default defineComponent({
    name: 'MsMap',
    components: {
        CsCopyTextLink,
        CsModal,
        CsTooltipModal,
        MsInformationCircle,
        CsSecondaryButton,
        CsTooltip,
        MsLocator,
        MsHeadline,
        MsGoogleMaps,
        MsPlaceholderMap,
    },
    props: {
        address: String,
        locationCoordinates: {
            type: Object as PropType<LocationCoordinates>,
            required: true,
        },
        isRealEstatePreview: Boolean,
        apiKey: {
            type: String,
            required: true,
        },
        relocationLink: {
            type: Object as PropType<PartnerLink | null>,
        },
        componentId: {
            type: String,
            required: true,
        },
    },

    setup(props) {
        const tooltipText = 'Die vollständige Adresse erhältst du von den Anbietenden.'
        const isAddressHidden = !props.locationCoordinates.showPin
        const { isScreenM } = screenSizeDetection()
        const isTooltipModalOpen = ref<boolean>(false)
        const requestContext = useGlobalStore().requestContext
        const currentUrl = requestContext?.url.href || ''
        const exposeeId = useDetailStore().exposeeId || -1
        const showMapModal = ref<boolean>(false)

        function closeModal() {
            showMapModal.value = false
        }
        function openMap() {
            showMapModal.value = true
            trackOpenMap()
        }

        function trackClickRelocation(): void {
            const tealiumData: TrackingParameter = buildTealiumTrackingRelocationClick(exposeeId)
            track(tealiumData)
        }

        function trackOpenMap(): void {
            const mlmData: MLM.TrackingData = buildMlmTrackingData(props.componentId, currentUrl, exposeeId)
            const tealiumData: TrackingParameter = buildTealiumTrackingOpenMap(exposeeId)

            MLM.trackClick(mlmData)
            track(tealiumData)
        }

        function updateVisible(): void {
            isTooltipModalOpen.value = !isTooltipModalOpen.value
        }

        return {
            tooltipText,
            openMap,
            showMapModal,
            isAddressHidden,
            isScreenM,
            updateVisible,
            trackClickRelocation,
            isTooltipModalOpen,
            closeModal,
        }
    },
})
